<template>
  <b-alert
    show
    :variant="`light-${variant}`"
    class="alert-custom py-2 px-4"
    :class="`text-${variant}`"
  >
    <i class="alert-icon font-size-h2" :class="`text-${variant} ${icon}`"></i>
    <div class="alert-text">
      <span v-if="text">
        {{ text }}
      </span>
      <slot></slot>
    </div>
  </b-alert>
</template>

<script>
export default {
  name: "GrowerWebAlert",

  props: {
    text: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: "info",
    },
    icon: {
      type: String,
      default: "ri-information-line",
    },
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/base/component/alert.vue